import React from 'react';
import { useProcurementStore } from '@/zustand';
import { FormProductManagerHeader } from './form-header';
import Grid from '@mui/material/Grid';
// import useEnvironmentFilters from 'src/logic/zustand/Filters/hooks/use-environment-filters';
// import { useAdvancedFiltersSlice } from 'src/logic/zustand/catalouge/advanced-filters';

type IProps = {
  children: React.ReactNode;
  canViewCatalog?: boolean;
};

const FormWithSummaryLayout = ({ children, canViewCatalog = false }: IProps) => {
  const environment = useProcurementStore(state => state.productFormManagerProperties.data.environment);

  // const { setEnvironmentFilters } = useAdvancedFiltersSlice(state => state.actions);
  // const envFilters = useEnvironmentFilters();

  // const hasPageBeenRendered = React.useRef<boolean>(false);
  // React.useEffect(() => {
  //   if (hasPageBeenRendered.current) {
  //     setEnvironmentFilters(envFilters, true);
  //   }
  //   hasPageBeenRendered.current = true;
  // }, [envFilters]);

  if (!environment) {
    return (
      <Grid container sx={{ width: '100%' }}>
        {children}
      </Grid>
    );
  }
  return (
    <Grid container sx={{ width: 'calc(100% - 350px)' }}>
      <FormProductManagerHeader canViewCatalog={canViewCatalog} />
      {children}
    </Grid>
  );
};

export default FormWithSummaryLayout;
